import { css } from '@emotion/core';

import { minTablet, minDesktop } from '../styles/breakpoints';
import { TextColor, PrimaryColor } from '../styles/colors';
import { PTMono } from '../styles/fonts';

export const SectionHeadlineFontStyles = css`
  color: ${TextColor};

  font-size: 16px;
  ${minTablet} {
    font-size: 20px;
  }
  ${minDesktop} {
    font-size: 22px;
  }
`;

export const SectionIdFontStyles = css`
  ${PTMono};

  color: ${PrimaryColor};

  font-size: 22px;
  ${minTablet} {
    font-size: 28px;
  }
  ${minDesktop} {
    font-size: 32px;
  }
`;

export const TextFontStyles = css`
  color: ${TextColor};

  font-size: 16px;
  ${minDesktop} {
    font-size: 18px;
  }
`;



// WEBPACK FOOTER //
// ./src/components/ExternalLinksCollection/styles.js